<template>
  <div>

    <v-row>
      <v-col cols="12">

        <div style="float: left" class="pt-1"><h4>Situação Atual - </h4></div>
        <div style="float: left"><v-checkbox label="não possui" @click.stop="currentSituationDialog = true"  class="mt-0" v-model="currentSituation.notExist" outlined dense></v-checkbox></div>
        <div class="pt-7"></div>
        <v-divider class="mb-4"></v-divider>
      </v-col>
    </v-row>

    <!-- Dialog aviso não possui -->
    <v-dialog
      v-model="currentSituationDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          Atenção!
        </v-card-title>

        <v-card-text v-if="this.currentSituation.notExist">
          As informações cadastradas nos cenários atual e proposto serão perdidos ao retirar a Situação Atual. Deseja continuar?
        </v-card-text>
        
        <v-card-text v-if="!this.currentSituation.notExist">
          As informações cadastradas no cenário proposto será perdido. Deseja continuar?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="currentSituationDialog = false; currentSituation.notExist=!currentSituation.notExist"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="notExistCurrentSituationControl"
          >
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  
    <HealthCareProviderDialog :current-situation="currentSituation" :benefit="benefit"
    :carrier-current-plans="carrierCurrentPlans" v-if="currentSituation.notExist==false"></HealthCareProviderDialog>
  
    <v-tabs v-model="currentSituationTab" v-if="currentSituation.carrier!=null">
      <v-tab class="primary--text" href="#tabs-1">
        {{ currentSituation.carrier.comercialName }}
        <v-btn icon small @click="removeProvider">
          <v-icon small dark title="Remover">fas fa-times</v-icon>
        </v-btn>
      </v-tab>
    </v-tabs>
  
    <v-row class="mt-0 pt-0"  v-if="currentSituation.carrier!=null">
      <v-col class="pt-0 pl-0">
        <v-tabs-items v-model="currentSituationTab">
          <v-tab-item value="tabs-1">
  
            <v-card elevation="0">
              <v-card-title class="pa-0">
                <v-card-actions>
                  <v-btn
                    icon
                    small
                    @click="showContractDrawCard = !showContractDrawCard"
                  >
                    <v-icon>{{ showContractDrawCard ? 'fas fa-minus' : 'fas fa-plus' }}</v-icon>
                  </v-btn>
                  
                </v-card-actions>
                Desenho do Benefício
              </v-card-title>
  
              <v-expand-transition>
                <div v-show="showContractDrawCard">
                  <v-card-text class="pt-0">
                    <v-row class="mt-0">
                      <v-col cols="4" class="pt-0">
                        <v-select :items="paymentSchemeTypes" v-model="currentSituation.benefitPolice.paymentScheme"
                                  label="Regime de Pagamento*" dense outlined></v-select>
                      </v-col>
                      <v-col cols="4" class="pt-0" v-if="currentSituation.benefitPolice.paymentScheme=='Pós-Pagamento'">
                        <v-text-field v-model="currentSituation.benefitPolice.administrationFee"
                                      label="Taxa de Administração*" dense outlined></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0" v-if="currentSituation.benefitPolice.paymentScheme=='Pré-Pagamento'">
                      <v-col cols="4" class="pt-0">
                        <v-text-field v-model="currentSituation.benefitPolice.readjustmentForecast"
                                      label="Previsão de reajuste*" v-mask="$util.formmasks.number" dense outlined></v-text-field>
                      </v-col>
                      <v-col cols="4" class="pt-0">
                        <v-text-field v-model="currentSituation.benefitPolice.lossRatio" v-mask="$util.formmasks.number"
                                      label="Sinistralidade*" dense outlined></v-text-field>
                      </v-col>
                      <v-col cols="4" class="pt-0">
                        <v-text-field v-model="currentSituation.benefitPolice.technicalLimit" v-mask="$util.formmasks.number"
                                      label="Limite Técnico*" dense outlined></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col cols="4" class="pt-0">
                        <v-select :items="monthTypes" v-model="currentSituation.benefitPolice.policyBirth"
                                  label="Aniversário da Apólice*" dense outlined></v-select>
                      </v-col>
                      <v-col cols="4" class="pt-0">
                        <v-select :items="contractModelTypes" v-model="currentSituation.benefitPolice.contractModel"
                                  label="Modelo da Contratação*" dense outlined></v-select>
                      </v-col>
                      <v-col cols="4" class="pt-0" v-if="currentSituation.benefitPolice.contractModel=='Adesão'">
                        <v-text-field v-model="currentSituation.benefitPolice.percentageTotalGroupMembership" v-mask="$util.formmasks.number"
                                      label="% de adesão sobre o grupo total" dense outlined append-outer-icon="fa fa-percentage"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-col cols="4" class="pt-0">
                        <v-text-field v-model="currentSituation.benefitPolice.contractDeadline"
                                      label="Prazo do Contrato*" dense outlined></v-text-field>
                      </v-col>
                      <v-col cols="4" class="pt-0">
                        <v-text-field v-model="currentSituation.benefitPolice.requestContractTerminationDeadline"
                                      label="Prazo para solicitar rescisão contratual*" dense outlined></v-text-field>
                      </v-col>
                      <v-col cols="4" class="pt-0">
                        <v-text-field v-model="currentSituation.benefitPolice.terminationFineOutOfDeadline"
                                      label="Multa de Recisão fora do prazo de vigência" dense outlined></v-text-field>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </div>
              </v-expand-transition>
            </v-card>
  
            <IncludeAgeGroupTable
              title="Distribuição por faixa etária geral"
              :general-age-group="currentSituation.ageGroupWithPlan"
              :show-distribution="true"
              :show-aggregate-peoples-percentage="true"
              :total-health-care-plan-age-group="totalHealthCarePlanAgeGroup">
            </IncludeAgeGroupTable>
  
            <IncludePlan ref="plansComponent" :plans="currentSituation.plans"
                         :total-health-care-plan-age-group="totalHealthCarePlanAgeGroup"
                         :benefit="benefit"
                         :account="currentSituation.carrier"
                         :carrier-current-plan="carrierCurrentPlans"
                         :carrier-proposed-plan="carrierProposedPlan">
            </IncludePlan>
  
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import HealthCareProviderDialog from "@/view/study/dialog/dlg_health_care_provider"
import IncludePlan from "@/view/study/includes/include_plan";
import IncludeAgeGroupTable from "@/view/study/includes/include_age_group_table"

export default {
  components: {
    IncludeAgeGroupTable, HealthCareProviderDialog, IncludePlan
  },
  data(){
    return {
      currentSituationDialog: false,
      currentSituationTab: null,
      showContractDrawCard: true,
      paymentSchemeTypes: ["Misto","Pré-Pagamento","Pós-Pagamento"],
      monthTypes: ["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],
      contractModelTypes: ["Adesão","Compulsório"],
      percentageTotalGroupMembership: null,
      totalHealthCarePlanAgeGroup: {
        untilEighteenPeople: 0,
        nineteenToTwentyThreePeoples: 0,
        twentyFourToTwentyEightPeoples: 0,
        twentyNineToThirtyThreePeoples: 0,
        thirtyFourToThirtyEightPeoples: 0,
        thirtyNineToFortyThreePeoples: 0,
        fortyFourToFortyEightPeoples: 0,
        fortyNineToFiftyThreePeoples: 0,
        fiftyFourToFiftyEightPeoples: 0,
        fromFiftyNinePeoples: 0,
        overall: 0,
      },
    }
  },
  props:{
    currentSituation: {
      type: Object
    },
    benefit: {
      type: Object
    },
    carrierCurrentPlans: {
      type: Object
    },
    carrierProposedPlan:{
      type: []
    },
    resetCurrentSituation: Function,
    addNotExistCurrentPlan: Function
  },
  methods:{
    removeProvider(){
      this.currentSituationTab=null;
      this.resetCurrentSituation(false);
    },
    getTotalHealthCarePlanAgeGroup(){
      return this.totalHealthCarePlanAgeGroup;
    },
    notExistCurrentSituationControl(){
      if(this.currentSituation.notExist){
        this.addNotExistCurrentPlan();
      } else {
        this.carrierCurrentPlans.plans.splice(0);
        this.carrierProposedPlan[0].plans.splice(0);
        this.carrierProposedPlan[1].plans.splice(0);
        this.carrierProposedPlan[2].plans.splice(0);
        this.carrierProposedPlan[3].plans.splice(0);
      }
      this.currentSituationDialog=false;
    },
    addCarrierProposedPlan(index){
      this.carrierProposedPlan[index].plans.push({
        plansType:[],
        linedPlans:[{
          product: {},
          consultationRefund: null,
          psychotherapyRefund: null,
          physiotherapyRefund: null,
          skullTomographyRefund: null,
          caesareanBirthRefund: null,
          revascularizationMyocardiumRefund: null,
          lives: null,
          copay:{averageCost: null},
          secondCopay:{averageCost: null},
          inactiveLives: null,
          inactiveCopay:{averageCost: null},
          inactiveSecondCopay:{averageCost: null},
          houseHoldLives: null,
          houseHoldCopay:{averageCost: null},
          houseHoldSecondCopay:{averageCost: null},
          upgradePlans: [],
          downgradePlans: [],
          ageGroupCost: [],
          inactiveAgeGroupCost: [],
          houseHoldAgeGroupCost: []
        }]
      });
      for (let i = 0; i < 10; i++) {
        this.carrierProposedPlan[index].plans[this.carrierProposedPlan[index].plans.length-1].linedPlans[0].ageGroupCost.push({
          id: i,
          lives: null,
          copayValue: null,
          secondCopayValue: null
        });
        this.carrierProposedPlan[index].plans[this.carrierProposedPlan[index].plans.length-1].linedPlans[0].inactiveAgeGroupCost.push({
          id: i,
          lives: null,
          copayValue: null,
          secondCopayValue: null
        });
        this.carrierProposedPlan[index].plans[this.carrierProposedPlan[index].plans.length-1].linedPlans[0].houseHoldAgeGroupCost.push({
          id: i,
          lives: null,
          copayValue: null,
          secondCopayValue: null
        });
      }
    },
  },
  name: "include_current_situation"
}
</script>

<style scoped>

</style>
